import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormGroup,
  InputAdornment,
  Radio,
  Stack,
  styled,
  Typography,
  useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useModal from '../../hooks/custom/useModal';
import { useCreateBuyTransaction } from '../../hooks/useCreateBuyTransaction';
import { useUpdateDividendOption } from '../../hooks/useUpdateDividendOption';
import { onRefresh } from '../../utils/refreshPage';
import { stringToBooleanInput } from '../../utils/stringToBoolean';
import { numberWithPoint } from '../../utils/utils';
import { ButtonsPrimary } from '../ComponentApp/buttoms';
import Spinner from '../Spinner';
import ModalActions, { SuccessfulInvestment } from '../UI/modalActions';
import ModalErrorFetch from '../UI/ModalErrorFetch';
import { FormatCurrency } from '../../utils/numbers';
import {
  AvailableBalanceBox,
  BackArrowContainer,
  BlueCard,
  CardTitle,
  ContainerTypos,
  FormLabelStyled,
  ImgStyled,
  InputLabelBox,
  InvestmentContainer,
  InvestmentInputStack,
  InvestmentLabel,
  InvestmentTextField,
  LeftColumnWrapper,
  MainBodyStack,
  RechargeWrapper,
  RightColumnWrapper,
  SectionTitle,
  SimulatorResultContainer,
  TitleSectionInvestment,
  TitleSectionWrapper,
  Typography1,
  Typography2,
  WarningBox,
  WarningIcon,
  WarningMessageStack,
  WarningText,
} from './SimulationComponents/SimulationMuiComponents';

const RechargeLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: theme.typography.customButton.fontSize,
  fontWeight: theme.typography.signInWelcome.fontWeight,
  textDecoration: 'none',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    marginTop: '6px',
  },
}));

const SimulatorInvestmentFunds = ({
  balanceData,
  loadingBalance,
  errorBalance,
  profileName,
  userRiskCondition,
  userRisk,
  refetch,
  statusDividendFinfolio,
  securitySelected,
  simulationId,
  fileAsComplete,
  formData,
}) => {
  const theme = useTheme();
  const { isShowing, toggle } = useModal();
  const [openModal, setOpenModal] = useState(false);
  const [sending, setSending] = useState(false);
  const [checked, setChecked] = useState({
    checkbox1: false,
    checkbox2: false,
  });
  const [selectedRadio, setSelectedRadio] = useState(statusDividendFinfolio?.Value);
  const location = useLocation();
  const navigate = useNavigate();
  const [amount, setAmount] = useState({
    initialInvestment: location.state?.fromCard ? '' : formData?.initialInvestment || '',
  });

  const [
    createBuyTransaction,
    { loading: loadingCreateTransaction, error: errorCreatetransaction },
  ] = useCreateBuyTransaction();

  const result = securitySelected || null;

  const safeResult = result || {};

  let custom = null;
  if (safeResult?.Custom) {
    try {
      custom =
        typeof safeResult.Custom === 'string' ? JSON.parse(safeResult.Custom) : safeResult.Custom;
    } catch (err) {
      console.warn('Error parsing Custom for security', err);
      custom = null;
    }
  }

  const minInvestmentAmount = custom?.fund_details?.min_investment_amount;

  const openTC = () => {
    const { REACT_APP_CONTRACT } = process.env;
    const win = window.open(REACT_APP_CONTRACT, '_blank');
    win.focus();
  };

  const getDisabled = () => {
    const { initialInvestment } = amount;
    const { checkbox1, checkbox2 } = checked;
    if (!initialInvestment) {
      return true;
    }
    const amountDynamic = minInvestmentAmount;
    if (initialInvestment && userRiskCondition) {
      return (
        Number.parseInt(initialInvestment?.replace(/\D/g, '')) < amountDynamic ||
        balanceData?.balance < Number.parseInt(initialInvestment?.replace(/\D/g, '')) ||
        initialInvestment[0] === '0' ||
        initialInvestment === null ||
        initialInvestment.trim() === '' ||
        !checkbox2 ||
        sending ||
        typeof selectedRadio === 'object'
      );
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (initialInvestment && !userRiskCondition) {
      return (
        Number.parseInt(initialInvestment?.replace(/\D/g, '')) < amountDynamic ||
        balanceData?.balance < Number.parseInt(initialInvestment?.replace(/\D/g, '')) ||
        initialInvestment[0] === '0' ||
        initialInvestment === null ||
        initialInvestment.trim() === '' ||
        !(checkbox1 && checkbox2) ||
        sending ||
        typeof selectedRadio === 'object'
      );
    }
  };

  const disable = getDisabled();

  const handleChangeRadio = event => {
    setSelectedRadio(event.target.value);
  };

  const handleChangeCheckBox = e => {
    const { name, checked: checkedInput } = e.target;
    setChecked({
      ...checked,
      [name]: checkedInput,
    });
  };

  const handleChangeAmount = e => {
    const { name, value } = e.target;

    const validAmount = value?.replace(/\D/g, '');
    if (validAmount?.toString()?.length <= 8) {
      const format = numberWithPoint(validAmount);

      setAmount(prevAmount => ({
        ...prevAmount,
        [name]: format,
      }));
    }
  };
  const validateAmount = value => {
    let errors;

    if (value.trim() === '') {
      errors = 'El campo es requerido';
    } else if (
      !value ||
      Number.parseInt(value?.replace(/\D/g, '')) < minInvestmentAmount ||
      value[0] === '0'
    ) {
      errors = `El monto mínimo para invertir en este fondo es de ${FormatCurrency(minInvestmentAmount)}`;
    }

    return errors;
  };

  const errorAmount = validateAmount(amount.initialInvestment);

  const handleSubmit = async amount => {
    setSending(true);

    const dataBuy = {
      amount: Number.parseInt(amount?.initialInvestment?.replace(/\D/g, '')),
      securityId: securitySelected?.ID,
      simulationId: simulationId,
      fund: securitySelected?.Name,
    };

    if (custom?.fund_details?.dividend_payment.includes('Si')) {
      if (selectedRadio === 'true') {
        dataBuy.dividendChoice = 'Reinvertir dividendos en el fondo';
      } else {
        dataBuy.dividendChoice = 'Depositar dividendos en la caja';
      }
    }

    try {
      const { data: responseCreateBuyTransaction } = await createBuyTransaction({
        variables: { data: dataBuy },
      });

      if (responseCreateBuyTransaction.createBuyTransaction) {
        refetch();
      }

      if (custom.fund_details.dividend_payment.includes('Si')) {
        const optionFound = {
          securityId: securitySelected.ID,
          selection: stringToBooleanInput(selectedRadio),
        };
        await setDividendOption({
          variables: { data: optionFound },
        });
      }

      setOpenModal(true);
    } catch (err) {
    } finally {
      setSending(false);
      setChecked({
        ...checked,
        checkbox1: false,
        checkbox2: false,
      });
    }
  };

  const [setDividendOption, { loading, error }] = useUpdateDividendOption();

  useEffect(() => {
    if (
      userRiskCondition ||
      userRisk === 'agresivo' ||
      (userRisk === 'moderado' && profileName?.trim()?.toLowerCase() === 'conservador')
    ) {
      setChecked(prevChecked => ({
        ...prevChecked,
        checkbox1: true,
      }));
    }
  }, [userRisk, userRiskCondition, profileName]);

  if (errorBalance || errorCreatetransaction) {
    return (
      <ModalErrorFetch
        message='Lo sentimos, algo no salio bien acá....'
        error={errorBalance || errorCreatetransaction}
        open={!isShowing}
        onClose={toggle}
        refresh={onRefresh}
      />
    );
  }

  if (loadingBalance || loadingCreateTransaction) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
          boxSizing: 'border-box',
          width: '100%',
          top: { md: '100px', xs: '50px' },
        }}>
        <Spinner />
      </Box>
    );
  }

  return (
    <>
      <ModalActions open={openModal}>
        <SuccessfulInvestment
          amountInvestment={amount.initialInvestment}
          fundName={fileAsComplete}
          onClose={() => {
            setOpenModal(false);
            navigate('/myprofilerisk');
          }}
        />
      </ModalActions>

      <SimulatorResultContainer>
        <BackArrowContainer>
          <Button
            onClick={() => navigate(-1)}
            style={{ background: 'none', border: 'none', padding: 0 }}>
            <ImgStyled src='/assets/images/Arrow1.svg' alt='Arrow' />
          </Button>
        </BackArrowContainer>

        <MainBodyStack>
          <LeftColumnWrapper>
            <TitleSectionWrapper>
              <TitleSectionInvestment>{fileAsComplete}</TitleSectionInvestment>
            </TitleSectionWrapper>

            <BlueCard>
              <Stack>
                <CardTitle>Condiciones generales</CardTitle>
              </Stack>
              <ContainerTypos>
                <Typography1>{'Monto mínimo de inversión(en pesos):'}</Typography1>
                <Typography2>{FormatCurrency(minInvestmentAmount)} </Typography2>
              </ContainerTypos>
              <ContainerTypos>
                <Typography1>Plazo de Aporte: </Typography1>
                <Typography2>{custom.fund_details.max_settle_date}</Typography2>
              </ContainerTypos>
              <ContainerTypos>
                <Typography1>Paga dividendos: </Typography1>
                <Typography2>{custom.fund_details.dividend_payment}</Typography2>
              </ContainerTypos>
            </BlueCard>
          </LeftColumnWrapper>

          <RightColumnWrapper>
            <SectionTitle>
              <TitleSectionInvestment>Inversión</TitleSectionInvestment>
            </SectionTitle>
            <BlueCard>
              <Stack>
                <CardTitle>Elige cuánto deseas invertir</CardTitle>
              </Stack>
              <InvestmentContainer>
                <InvestmentInputStack>
                  <InputLabelBox>
                    <InvestmentLabel>Inversión Inicial</InvestmentLabel>
                    <InvestmentTextField
                      fullWidth
                      variant='standard'
                      type='text'
                      name='initialInvestment'
                      InputProps={{
                        startAdornment: <InputAdornment position='start'>$</InputAdornment>,
                        fontSize: theme.typography.availableBalance.fontSize,
                      }}
                      onChange={handleChangeAmount}
                      value={amount.initialInvestment}
                      error={Boolean(errorAmount)}
                      helperText={errorAmount}
                    />
                  </InputLabelBox>
                  <AvailableBalanceBox>
                    <img
                      style={{
                        backgroundColor: '#edfcf9',
                        marginRight: '4px',
                      }}
                      width={'26px'}
                      height='26px'
                      src='/assets/images/cashBox.gif'
                      alt='gift'
                    />
                    * Monto Disponible ${numberWithPoint(Math.round(balanceData?.balance))}
                  </AvailableBalanceBox>
                  {balanceData?.balance <
                  Number.parseInt(amount.initialInvestment?.replace(/\D/g, '')) ? (
                    <WarningBox>
                      <img
                        style={{
                          backgroundColor: 'rgb(220, 53, 69,0.1)',
                          marginRight: '4px',
                        }}
                        width={'26px'}
                        height='26px'
                        src='/assets/images/cashBox.gif'
                        alt='gift'
                      />
                      *
                      {` Monto por recargar $${numberWithPoint(
                        Number.parseInt(
                          amount.initialInvestment?.replace(/\D/g, '') - balanceData.balance,
                        ),
                      )}`}
                    </WarningBox>
                  ) : null}
                </InvestmentInputStack>
              </InvestmentContainer>

              {balanceData?.balance <
                Number.parseInt(amount.initialInvestment?.replace(/\D/g, '')) && (
                <RechargeWrapper>
                  <WarningMessageStack>
                    <WarningIcon
                      component='img'
                      src='/assets/images/maintenancetriangle.svg'
                      alt='Ícono de advertencia'
                    />
                    <WarningText sx={{ ml: '6px' }}>
                      No tienes suficientes fondos en caja
                    </WarningText>
                  </WarningMessageStack>
                  <Stack width={'100%'} alignItems='center'>
                    <RechargeLink
                      as='button'
                      onClick={() => {
                        navigate('/payments');
                      }}>
                      Recargar caja
                    </RechargeLink>
                  </Stack>
                </RechargeWrapper>
              )}
            </BlueCard>
          </RightColumnWrapper>
        </MainBodyStack>
        <Stack
          width={'100%'}
          sx={{
            mt: {
              md: 4,
              xs: custom.fund_details.dividend_payment.includes('Si') ? 4 : undefined,
            },
          }}>
          {custom.fund_details.dividend_payment.includes('Si') && (
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'column',
                mb: { md: 5, xs: 0 },
              }}>
              <Box>
                <Typography
                  sx={{
                    fontSize: {
                      xs: theme.typography.button.fontSize,
                      md: theme.typography.availableBalance.fontSize,
                    },
                  }}
                  fontWeight={theme.typography.littleText.fontWeight}
                  color={theme.palette.primary.main}>
                  Este fondo genera dividendos mensuales.
                </Typography>
              </Box>

              <Box sx={{ mt: '10px' }}>
                <Typography
                  fontWeight={theme.typography.littleText.fontWeight}
                  color={theme.palette.primary.darkBlue}
                  fontSize={theme.typography.button.fontSize}>
                  ¿Qué quieres hacer con estos dividendos?
                </Typography>
              </Box>

              <Box
                sx={{
                  mt: { md: '14px', xs: '10px' },
                  ml: '-10px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'start',
                  width: '100%',
                  mb: 0,
                  gap: 0,
                }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Radio
                    sx={{
                      '&.Mui-checked': {
                        color: theme.palette.secondary.main,
                        '&.Mui-focusVisible': { outline: '2px auto #49a197' },
                      },
                    }}
                    checked={selectedRadio === 'true'}
                    onChange={handleChangeRadio}
                    value='true'
                    name='radio-buttons'
                  />
                  <FormLabelStyled
                    sx={{
                      color: theme.palette.secondary.main,
                      fontWeight: theme.typography.button.fontWeight,
                    }}>
                    Prefiero reinvertir en este fondo
                  </FormLabelStyled>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Radio
                    sx={{
                      '&.Mui-checked': {
                        color: theme.palette.secondary.main,
                        '&.Mui-focusVisible': { outline: '2px auto #49a197' },
                      },
                    }}
                    checked={selectedRadio === 'false'}
                    onChange={handleChangeRadio}
                    value='false'
                    name='radio-buttons'
                  />
                  <FormLabelStyled
                    sx={{
                      color: theme.palette.secondary.main,
                      fontWeight: theme.typography.button.fontWeight,
                    }}>
                    Depositar dividendos en la caja
                  </FormLabelStyled>
                </Box>
              </Box>
            </Stack>
          )}
        </Stack>

        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <FormGroup
            sx={{
              gap: '10px',
            }}>
            {userRiskCondition ||
            userRisk === 'agresivo' ||
            (userRisk === 'moderado' &&
              profileName?.trim()?.toLowerCase() === 'conservador') ? null : (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  width: '100%',
                  justifyContent: 'center',
                  width: '100%',
                  flexWrap: 'wrap',
                  mt: {
                    xs: 7,
                    md: 1,
                  },
                }}>
                <Checkbox
                  checked={checked.checkbox1}
                  name='checkbox1'
                  onChange={handleChangeCheckBox}
                />
                <FormLabelStyled>
                  Declaro entender que la inversión que estoy realizando es de un riesgo superior a
                  lo sugerido por mi perfil inversionista.
                </FormLabelStyled>
              </Box>
            )}

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'center',
                flexWrap: 'wrap',
                mt: {
                  xs: '12px',
                  md: '-10px',
                },
              }}>
              <Checkbox
                checked={checked.checkbox2}
                name='checkbox2'
                onChange={handleChangeCheckBox}
              />
              <FormLabelStyled>
                {'Acepto que esta transacción se rigen bajo las normas del '}
                {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
                <span
                  onClick={openTC}
                  style={{
                    cursor: 'pointer',
                    color: theme.palette.secondary.main,
                    fontWeight: theme.typography.button.fontWeight,
                  }}>
                  contrato vigente.
                </span>
              </FormLabelStyled>
            </Box>
          </FormGroup>
        </Box>

        <Stack
          alignItems={'center'}
          justifyContent={'space-between'}
          mt={{ lg: 5, md: 5, sm: 4, xs: 4 }}
          width={'90%'}>
          <Box width={{ lg: '35%', md: '40%', sm: '60%', xs: '80%' }}>
            <ButtonsPrimary
              name='Invertir'
              onClick={() => handleSubmit(amount)}
              disabled={disable}
              fullWidth
            />
          </Box>

          <Box mt={3} mb={3}>
            {balanceData?.balance <
            Number.parseInt(amount.initialInvestment?.replace(/\D/g, '')) ? (
              <Alert severity='info'>
                Por favor valida el monto ingresado, el monto es mayor al disponible en caja.
              </Alert>
            ) : Number.parseInt(amount.initialInvestment?.replace(/\D/g, '')) <
              minInvestmentAmount ? (
              <Alert severity='info'>
                Por favor valida el monto ingresado, el monto mínimo para invertir es de{' '}
                {FormatCurrency(minInvestmentAmount)}
              </Alert>
            ) : amount.initialInvestment.trim() === '' ? (
              <Alert severity='info'>Por favor ingrese un monto a invertir</Alert>
            ) : checked.checkbox1 && checked.checkbox2 && typeof selectedRadio === 'object' ? (
              <Alert severity='info'>Por favor seleccione que desea hacer con sus dividendos</Alert>
            ) : checked.checkbox1 && checked.checkbox2 ? (
              <Alert severity='success'>Todo está listo para invertir</Alert>
            ) : null}
          </Box>

          <Box
            display={'flex'}
            justifyContent={'center'}
            width={'150px'}
            height={'40px'}
            sx={{
              marginBottom: {
                xs: '28px',
                md: '8px',
              },
              marginTop: {
                xs: '-10px',
                md: '0px',
              },
            }}>
            <Link to={'/'}>
              <Typography
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  color: 'rgba(239, 140, 122, 1)',
                  fontWeight: theme.typography.smallText.fontWeight,
                  fontSize: theme.typography.button.fontSize,
                  textDecoration: 'underline',
                }}>
                No por ahora
              </Typography>
            </Link>
          </Box>
        </Stack>
      </SimulatorResultContainer>
    </>
  );
};

export default SimulatorInvestmentFunds;
